/*global define, console, window, HTMLImageElement, Promise*/
(window.MyModule = function ($, Behaviors) {
    "use strict";
    var module = {};
    function AnchorItems(elem) {
        Behaviors.init(AnchorItems, this, arguments);

        var $thisElem = this.$elem;

        var $sidebar = $('.AnchorItems-content_items');
        var offset = $sidebar.offset();

        var footerSize = $("footer[data-type='footer']");
        var notActiveSection = $('.fl-builder-content-primary > div.fl-row:not([id^="section-id-"], div:first-child)');

        var animationElements = $('[id^="section-id-"]');

        var wpToolBar = $('#wpadminbar');
        var stickyHeaderInterval;

        var $window = $(window);

        setTimeout(function(){
            offset = $sidebar.offset();
        },500);

        function sectionNav() {

            clearTimeout($.data(this, 'scrollTimer'));
            if ($sidebar.length > 0) {

                $.data(this, 'scrollTimer', setTimeout(function () {

                    var scrollTop = $window.scrollTop() + $('header.fl-builder-content').outerHeight();

                    $.each(animationElements, function (index) {

                        // sectionDetect($(this));

                        var $this = $(this);
                        if (scrollTop >= $this.offset().top && scrollTop < $this.offset().top + $this.height()) {
                            if (!$('.AnchorItems-content_item').eq(index).hasClass('AnchorItems-content_item--active')) {
                                $('.AnchorItems-content_item').removeClass('AnchorItems-content_item--active');
                                $('.AnchorItems-content_item').eq(index).addClass('AnchorItems-content_item--active');
                            }
                        }

                    });
                    var position = document.querySelector('.AnchorItems-content_item.AnchorItems-content_item--active') ? document.querySelector('.AnchorItems-content_item.AnchorItems-content_item--active').offsetTop - $sidebar.outerHeight() : 0;
                    $sidebar.animate({
                        'scrollTop': position
                    }, 300);
                }, 20));
            }
            var sidebarTopPosition = 0;

            if($(".AnchorItems-content_items").length > 0) {
                if ($('#wpadminbar').length > 0) {
                    $sidebar.addClass("has-wp-admin-bar");
                }
                if(wpToolBar.length > 0) {
                    sidebarTopPosition += wpToolBar.outerHeight();
                }
                if ( $window.scrollTop() > offset.top - sidebarTopPosition ) {
                    clearInterval(stickyHeaderInterval);

                    var footerTopPosition = ( $(document).height() - footerSize.outerHeight() - notActiveSection.outerHeight() + ($window.height() - $sidebar.outerHeight() - 40));
                    var windowScorllBottom = $window.scrollTop() + $window.height();
                    
                    if( windowScorllBottom > footerTopPosition ){
                        if ($('#wpadminbar').length > 0) {
                            $sidebar.css('top', sidebarTopPosition + (footerTopPosition - windowScorllBottom) + 0);
                        } else {
                            $sidebar.css('top', sidebarTopPosition + (footerTopPosition - windowScorllBottom) + 16);
                        }
                    }
                }
            }
        }

        $window.on('scroll', sectionNav);

        $('.AnchorItems-content_item > a').on('click', function(event){
            event.preventDefault();
            var targetDiv = $(this.dataset.href);
            
            var offsetToolBar = 0;
            if((wpToolBar).length > 0) {
                var offsetToolBar = wpToolBar.outerHeight();
            }
            
            if((targetDiv).length > 0) {
                $('html, body').animate({
                    scrollTop: targetDiv.offset().top
                }, 1);
            }
            
        });

    }
    Behaviors.inherit(AnchorItems, Behaviors.Behavior);
    AnchorItems.QUERY = "[data-AnchorItems]";
    AnchorItems.ELEMENTS = {
        loadMoreButton: ".AwardTabs-content_tabs_items_item_loadMore__button",
    };
    Behaviors.register_behavior(AnchorItems);
    module.AnchorItems = AnchorItems;
    return module;
}(window.jQuery, window.Behaviors));
